import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { ReactComponent as KuwaitFlag } from "./flags/kuwait.svg";
import { ReactComponent as QatarFlag } from "./flags/qatar.svg";
import { ReactComponent as UAEFlag } from "./flags/uae.svg";
import { ReactComponent as OmanFlag } from "./flags/oman.svg";
import { ReactComponent as BahrainFlag } from "./flags/bahrain.svg";
import { ReactComponent as SaudiFlag } from "./flags/sa.svg";
import { ReactComponent as USAFlag } from "./flags/usa.svg";
import { ReactComponent as EURFlag } from "./flags/euro.svg";
import { ReactComponent as UKFlag } from "./flags/uk.svg";
import { ReactComponent as JordanFlag } from "./flags/jordan.svg";
import { ReactComponent as SaudiRiyal } from "../../Helpers/Saudi_Riyal_Symbol-2.svg";
import { connect } from "react-redux";

function DialogSelect({
  handleClose,
  countries,
  currency,
  handleOk,
  language,
  settings,
}) {
  const [selectedCurrency, setSelectedCurrency] = React.useState(
    currency.selected,
  );
  if (selectedCurrency === "sar") {
    setSelectedCurrency("sa");
  }

  const handleChange = (event) => {
    setSelectedCurrency(event.target.value || "");
  };
  const flagStyle = { width: 20, height: 20, marginRight: 10 };

  const flags = {
    kw: <KuwaitFlag style={flagStyle} />,
    bh: <BahrainFlag style={flagStyle} />,
    qa: <QatarFlag style={flagStyle} />,
    sa: <SaudiFlag style={flagStyle} />,
    om: <OmanFlag style={flagStyle} />,
    ae: <UAEFlag style={flagStyle} />,
    us: <USAFlag style={flagStyle} />,
    eu: <EURFlag style={flagStyle} />,
    gp: <UKFlag style={flagStyle} />,
    jo: <JordanFlag style={flagStyle} />,
  };
  const dialCodes = {
    kwd: "kw",
    bhd: "bh",
    qar: "qa",
    sar: "sa",
    omr: "om",
    aed: "ae",
    usd: "us",
    eur: "eu",
    gbp: "gp",
    jod: "jo",
  };
  const menuItems = settings.currency_converter_currencies
    .split(",")
    .map((iso) => (
      <MenuItem value={dialCodes[iso]}>
        {flags[dialCodes[iso]]}{" "}
        {iso.toUpperCase() === "sa" ? "" : iso.toUpperCase()}
      </MenuItem>
    ));
  return (
    <div>
      <Dialog disableEscapeKeyDown open={true} onClose={handleClose}>
        <DialogTitle style={{ fontSize: 16 }}>
          {language === "arabic" ? "اختر العملة" : "Choose currency"}
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedCurrency}
              label="Currency"
              onChange={handleChange}
              style={{ textAlign: "center" }}
            >
              {menuItems}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose()}>
            {language === "arabic" ? "الغاء" : "Cancel"}
          </Button>
          <Button onClick={() => handleOk(selectedCurrency)}>
            {language === "arabic" ? "تم" : "Ok"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    currency: state.currency,
    countries: state.store.store.enabled_countries,
    settings: state.store.store.settings,
    language: state.store.language,
  };
};
export default connect(mapStateToProps)(DialogSelect);
